import {Entity} from "../../core/commons/entity";
/**
 * Created by Federico on 25/03/2017.
 */
export class Language implements Entity {
    public id: number = null;
    public name: string = "";
    public visibleTo: string = "0";
    public level: string = "";

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

}


// WEBPACK FOOTER //
// ./src/app/profile/domain/language.ts